import { dateFilterFields } from '../../components/filters/utils/definitions';
/** Checks if the given condition is a date condition. */
export const isDateCondition = (condition) => dateFilterFields.includes(condition.field);
